import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactModel } from '../contact/contact/contact.model';
import { ContactService } from '../contact/contact/contact.service';
import { ScheduleModel } from './schedule.model';
import { PreinvoiceScheduleWrapperComponent } from './preinvoice-schedule-wrapper.component';
import { ConceptService } from '../concept/concept/concept.service';
import { ConceptModel } from '../concept/concept/concept.model';
import { ScheduleService } from './schedule.service';
import { NewEventDialogComponent } from './new-event-dialog.component';
import { MasterService } from '../../modules_v2/master/services/master.service';

@Component({
    selector: 'app-schedule-details-dialog',
    templateUrl: './schedule-details-dialog.component.html',
    styleUrls: ['./schedule-details-dialog.component.css'],
    standalone: false
})
export class ScheduleDetailsDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<ScheduleDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private contactService: ContactService,
        private masterService: MasterService,
        private conceptService: ConceptService,
        private scheduleService: ScheduleService,
        public dialog: MatDialog,
    ) { }

    contact: ContactModel;
    concept: ConceptModel;
    working = true;

    contacts: any[] = [];
    concepts: any[] = [];

    ngOnInit() {

        this.masterService.getContacts().subscribe(response => {
            this.contacts = response.map(item => ({
                uid: item.id,
                companyName: item.display
            }));
        });

        this.masterService.getConcepts().subscribe(response => {
            this.concepts = response.map(item => ({
                uid: item.id,
                name: item.display
            }));
        });

        this.load();
    }

    load() {
        this.contactService.loadData(this.data.newEvent.contactUid).then(response => {
            this.contact = response;
            if (this.data.newEvent.conceptUid != '00000000-0000-0000-0000-000000000000') {
                this.conceptService.loadData(this.data.newEvent.conceptUid).then(response => {
                    this.concept = response;
                    this.working = false;
                });
            } else {
                const raw = this.data.newEvent.observations || '';
                const index = raw.indexOf('Concepto libre:');
                let conceptoLibre = '';
                if (index !== -1) {
                    conceptoLibre = raw.substring(index + 'Concepto libre:'.length).trim();
                }

                this.concept = new ConceptModel();
                this.concept.name = conceptoLibre;
                this.working = false;
            }
        });
    }

    delete() {
        this.scheduleService.delete(this.data.newEvent.id).subscribe(response => {
            this.dialogRef.close();
        });

    }

    newEvent: ScheduleModel = {
        id: 0,
        activityId: 0,
        title: '',
        contactUid: '',
        conceptUid: '',
        description: '',
        observations: '',
        startDate: '',
        endDate: '',
        isAllDay: false,
        createdAt: '',
    };

    edit() {
        this.dialog.open(NewEventDialogComponent, {
            width: '800px',
            data: { newEvent: this.data.newEvent, contacts: this.contacts, concepts: this.concepts }
        }).afterClosed().subscribe(() => this.load());
    }

    createPreinvoice() {
        this.dialog.open(PreinvoiceScheduleWrapperComponent, {
            data: {
                newEvent: this.data.newEvent,
                contacts: this.data.contacts
            }
        });
        this.dialogRef.close();
    }
}
